/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { ARMcontext } from '../context/context';
import { BrowserRouter, Routes, Route, Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
  TeamsPage,
  Login,
  Admin,
  Exams,
  Config,
  Health,
  Players,
  Armcare,
  Velocity,
  Scorecard,
  Workloads,
  HowToVideos,
  Leaderboard,
  PlayerVelocity,
  ForgotPassword,
  PlayerWorkloads,
  PurchaseComplete,
  ResetPassword,
  VerifyAccount
} from '../../pages';
import Auth from '../api/Auth';
import { Toast } from '../../components';
import PlayerPortal from '../../pages/player/playerPortal/PlayerPortal';
import ConfigPlayer from '../../pages/config/configPlayer';

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const orgToken = urlParams.get('orgToken')
const outsidePath = [
  { path: "/verify-account", element: <VerifyAccount />},
  { path: "/reset-password", element: <ResetPassword /> },
  { path: "/success", element: <PurchaseComplete /> },
  { path: "/forgot-password", element: <ForgotPassword /> },
  { path: "/create-account", element: <Navigate to="/login" replace /> },
  { path: "/login", element: <Login /> }
];

export default () => {
  const navigate = useNavigate();
  const { user, toast, HandleUser, HandleSignOut } = React.useContext(ARMcontext);
  const location = useLocation();
  const AUTH = new Auth();

  useEffect(() => {
    if (orgToken) {
      logFromToken();
    }
  }, [])

    useEffect(()=>{
      if(user === null){
        HandleSignOut();
        const validatedPath = outsidePath.map( path => path.path);
        if(!validatedPath.includes(location.pathname)){
          navigate('/login');
        }
      }
    },[user])

  useEffect(() => {
    window.addEventListener('error', e => {
      console.log("Error", e)
      if (e.message === "ResizeObserver loop completed with undelivered notifications.") {
        const resizeObserverErrDiv = document.getElementById(
            'webpack-dev-server-client-overlay-div'
        );
        const resizeObserverErr = document.getElementById(
            'webpack-dev-server-client-overlay'
        );
        if (resizeObserverErr) {
            resizeObserverErr.setAttribute('style', 'display: none');
        }
        if (resizeObserverErrDiv) {
            resizeObserverErrDiv.setAttribute('style', 'display: none');
        }
      }
    });
  }, []);

  async function logFromToken() {
    HandleSignOut();
    const response = await AUTH.logFromToken({
      access_token: orgToken,
      role: 'org-admin'
    });

    if (response.status) {
      if(response.data.data.role === 'player') {
        response.data.role = response.data.data.role
        response.data.secondaryRole = 'org-admin'
      }
      HandleUser(response.data);
    }
  }


  return (
    <>
      {toast.status ? <Toast toast={toast} /> : <></>}
      <Routes>
        {
          user?.data?.isFirstLogin && user?.access_token && user?.role === 'org-admin' && user?.data.role !== "player" && <>
            <Route path="/config" element={<Config />} />
            <Route path="/" element={<Config />} />
          </>
        }
        {
          user?.access_token ? (
            user?.role === 'player' ? (
              <>
                <Route path="/exams" element={<Exams />} />
                <Route path="/leaderboard" element={<Leaderboard />} />
                <Route path="/scorecard" element={<Scorecard />} />
                <Route path="/health" element={<Health />} />
                <Route path="/workloads" element={<PlayerWorkloads />} />
                <Route path="/velocity" element={<PlayerVelocity />} />
                <Route path="/config-player" element={<ConfigPlayer />} />

                <Route path="player-portal/*" element={<PlayerPortal />} />
                <Route path="/how-to-videos" element={<HowToVideos />} />
                <Route path="*" element={<Navigate to={'/player-portal'} replace />} />
              </>
            ) : (
              <>
                {(user?.role === 'org-admin' || user?.data.isAdmin) && <Route path="admin/*" element={<Admin />} />}
                <Route path="players/*" element={<Players />} />
                <Route path="teams/*" element={<TeamsPage />} />
                <Route path="/how-to-videos" element={<HowToVideos />} />
                {/* <Route path="/dashboard" element={<Dashboard />} /> */}
                <Route path="/config" element={<Config />} />
                <Route path="/armcare" element={<Armcare />} />
                <Route path="/velocity" element={<Velocity />} />
                <Route path="/workloads" element={<Workloads />} />
                <Route path="/" element={<TeamsPage />} />
                <Route path="*" element={<Navigate to={'/teams'} replace />} />
              </>
            )
          ):(
            <>
              {
                outsidePath.map( path => (
                  <Route path={path.path} element={path.element} />
                ))
              }
              <Route path="*" element={<Navigate to={'/login'} replace />} />
            </>
          )
        }
      </Routes>
    </>
  );
};
